import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {SearchMainVo} from '../../common/shared/api/nicolas/vo/SearchMainVo.interface';

/**
 * 검색 메인 (인기 검색어)
 *
 * Origin: pageNicolasApi.getSearchMain
 * API: GET /gateway/api/v1/search/main
 */
export async function getSearchMain(
  options?: FetcherOptions
): Promise<ApiResultVo & {result: SearchMainVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/search/main',
    {
      method: 'GET',
    },
    options
  );

  return response.data;
}
